import React, { Component } from "react";
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import { userloginDetails } from "../Utils/AdminAuth";
import { HOST_URL } from "../Dashboard/api/Api";
import Spining from "../UI/Spining/Spining";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faEye,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { date } from "yup/lib/locale";
import ReactTelInput from "react-telephone-input";
import flags from "../Dashboard/assets/img/flags.png";
import Axios from "../../axios/Axios";
import { handleUserLog } from "../Utils/Utils";

class AddNewClient extends Component {
  constructor() {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const type = lStorage.user.isAdmin
    var today = new Date(),
      date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        ("0" + today.getDate()).slice(-2);
    super();

    this.state = {
      user_id: userId,
      token: userToken,
      userDtl: lStorage,
      email: "",
      mobile: "",
      fullname: "",
      password: "",
      userType: "client",
      successMessage: false,
      errorMessage: "",
      bgColor: "",
      loading: false,
      currency: "INR",
      expiryDate: date,
      defaultCountry: "in",
      checkBox: {
        all: null,
        sms: null,
        voice: null,
        email: null,
        whatsapp: null,
        recharge: null,
        notification: null,
        rich_media: null,
        fallback: null,
        rcs: null,
        chat: null,
        flow: null
      },
    };
    this.handleCheckboxAll = this.handleCheckboxAll.bind(this);
  }

  componentDidMount = () => {
    this.setState((prevState) => ({
      checkBox: {
        ...prevState.checkBox,

        // ["sms"]: this.state.userDtl.user.sms_menu,
        // ["voice"]: this.state.userDtl.user.voice_menu,
        // ["email"]: this.state.userDtl.user.email_menu,
        // ["whatsapp"]: this.state.userDtl.user.whatsapp_menu,
        // ["recharge"]: this.state.userDtl.user.rechrg_menu,
        // ["notification"]: this.state.userDtl.user.notify_menu,
        // ["rich_media"]: this.state.userDtl.user.rich_menu,
        // ["fallback"]: this.state.userDtl.user.fb_menu,
        // ["rcs"]: this.state.userDtl.user.rcs_menu,
        // ["chat"]: this.state.userDtl.user.chat_menu,
        // ["flow"]: this.state.userDtl.user.flow
      },
    }));
    // if (
    //   this.state.userDtl.user.sms_menu === 1 &&
    //   this.state.userDtl.user.voice_menu === 1 &&
    //   this.state.userDtl.user.email_menu === 1 &&
    //   this.state.userDtl.user.whatsapp_menu === 1 &&
    //   this.state.userDtl.user.rechrg_menu === 1 &&
    //   this.state.userDtl.user.notify_menu === 1 &&
    //   this.state.userDtl.user.rich_menu === 1 &&
    //   this.state.userDtl.user.fb_menu === 1 &&
    //   this.state.userDtl.user.rcs_menu === 1 &&
    //   this.state.userDtl.user.chat_menu === 1 &&
    //   this.state.userDtl.user.flow === 1
    // ) {
    //   this.setState((prevState) => ({
    //     checkBox: {
    //       ...prevState.checkBox,

    //       ["all"]: 1,
    //     },
    //   }));
    // }
  }

  AddnewClients = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    const payload = {
      user_id: this.state.user_id,
      name: this.state.fullname,
      email: this.state.email,
      mobile: this.state.mobile,
      password: this.state.password,
      expiry: this.state.expiryDate,
      method: "adduser",
      token: this.state.token,
      user_type: this.state.userType,
      currency: this.state.currency,

      // Menus
      whatsapp_menu: this.state.checkBox.whatsapp,
      sms_menu: this.state.checkBox.sms,
      voice_menu: this.state.checkBox.voice,
      email_menu: this.state.checkBox.email,
      rechrg_menu: this.state.checkBox.recharge,
      notify_menu: this.state.checkBox.notification,
      rich_menu: this.state.checkBox.rich_media,
      fb_menu: this.state.checkBox.fallback,
      rcs_menu: this.state.checkBox.rcs,
      chat_menu: this.state.checkBox.chat,
      flow_menu: this.state.checkBox.flow,
    };

    try {

      let { data } = await Axios.post(`${HOST_URL}/admin_user_list.php`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (data.success === true) {
        this.setState({
          successMessage: true,
          bgColor: "alert alert-success alert-dismissible",
          errorMessage: data.message,
        });
        handleUserLog("", "user_signup", "Signup", "Signup Complete", "add_new_client", "", payload)
      } else {
        this.setState({
          successMessage: true,
          bgColor: "alert alert-danger alert-dismissible",
          errorMessage: data.message,
        });
        handleUserLog("", "user_signup", "Signup", data.message, "add_new_client", "", payload)
      }
    } catch (error) {
      // console.log(error);
      this.setState({
        successMessage: true,
        bgColor: "alert alert-danger alert-dismissible",
        errorMessage: error.message,
      });
      handleUserLog("", "user_signup", "Signup", error.data.message, "add_new_client", "", payload)
    } finally {
      this.setState({ loading: false });
    }
  };


  expiryDate = (date) => {
    let dated =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    this.setState({
      expiryDate: dated,
      SelectedexpiryDate: date,
    });
  };

  handleCheckboxAll(e) {
    const { checked } = e.target;
    let value;
    if (checked === true) {
      value = 1;
    } else {
      value = 0;
    }
    this.setState((prevState) => ({
      checkBox: {
        ...prevState.checkBox,
        all: value,
        sms: value,
        voice: value,
        email: value,
        whatsapp: value,
        recharge: value,
        notification: value,
        rich_media: value,
        fallback: value,
        rcs: value,
        chat: value,
        flow: value
      },
    }));
  }

  handleCheckbox = (e) => {
    const { name, checked } = e.target;
    let value;
    if (checked === true) {
      value = 1;
    } else {
      value = 0;
    }
    this.setState((prevState) => ({
      checkBox: {
        ...prevState.checkBox,
        [name]: value,
      },
    }));
  };

  handleInputChange = (telephone, selectedCountry) => {
    if (selectedCountry) {
      const { dialCode, iso2 } = selectedCountry;
      this.setState({
        countryCode: dialCode,
        selectedCountryCode: iso2,
      });
    }
  };



  render() {
    return (
      <div className="wrapper">
        <AdminLeftMenu />
        <div className="main">
          <AdminHeader />
          {this.state.loading && <Spining />}
          <main className="content">
            <div className="container-fluid p-0">
              <div className="row mb-2 mb-xl-3">
                <div className="col-auto d-none d-sm-block">
                  <h3>
                    <strong>Add New </strong> Client{" "}
                  </h3>
                </div>

                {this.state.successMessage ? (
                  <div className={this.state.bgColor} role="alert">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                    <div className="">{this.state.errorMessage}</div>
                  </div>
                ) : null}
              </div>
              <div className="row">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                        <div className=" flex-fill">
                          <form onSubmit={(e) => this.AddnewClients(e)}>
                            <div className="row">
                              <div className="mb-3 col-md-6">
                                <label
                                  className="form-label"
                                  htmlFor="inputFirstName"
                                >
                                  User Type{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  required
                                  className="form-control"
                                  aria-label="Default select example"
                                  value={this.state.userType}
                                  disabled
                                  onChange={(event) =>
                                    this.setState({
                                      userType: event.target.value,
                                    })
                                  }
                                >
                                  <option value="" selected>
                                    Select Type
                                  </option>
                                  <option value="client">Client</option>
                                </select>
                              </div>
                              <div className="mb-3 col-md-6">
                                <label
                                  className="form-label"
                                  htmlFor="inputFirstName"
                                >
                                  Currency {" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  required
                                  className="form-control"
                                  placeholder="Select Currency"
                                  aria-label="Default select example"
                                  value={this.state.userDtl.user.country_currency}
                                  disabled={true}
                                  onChange={(event) =>
                                    this.setState({
                                      userType: event.target.value,
                                    })
                                  }
                                >
                                  <option value="">Select Currency</option>
                                  <option value="INR">
                                    INR
                                  </option>
                                  <option value="EUR">EUR</option>



                                </select>
                              </div>
                              <div className="mb-3 col-md-6">
                                <label
                                  className="form-label"
                                  htmlFor="inputFirstName"
                                >
                                  Full Name{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  required
                                  onChange={(event) =>
                                    this.setState({
                                      fullname: event.target.value,
                                    })
                                  }
                                  className="form-control"
                                  placeholder="Enter Full Name"
                                />
                              </div>
                              <div className="mb-3 col-md-6">
                                <label
                                  className="form-label"
                                  htmlFor="inputEmail4"
                                >
                                  Email <span className="text-danger">*</span>
                                </label>
                                <input
                                  required
                                  type="email"
                                  onChange={(event) =>
                                    this.setState({
                                      email: event.target.value,
                                    })
                                  }
                                  className="form-control"
                                  placeholder="Email"
                                />
                              </div>
                              <div className="mb-3 col-md-6">
                                <label
                                  className="form-label"
                                  htmlFor="inputFirstName"
                                >
                                  Enter Mobile Number{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                {/* <input
                                  required
                                  type="text"
                                  onChange={(event) =>
                                    this.setState({
                                      mobile: event.target.value,
                                    })
                                  }
                                  className="form-control"
                                  placeholder="Enter 10 Digit Mobile Number"
                                /> */}
                                <div className="input-group">
                                  <div className="input-group-prepend ReactTelFullbox">
                                    <ReactTelInput
                                      defaultCountry={this.state.defaultCountry}
                                      flagsImagePath={flags}
                                      onChange={this.handleInputChange}
                                    />
                                  </div>
                                  <input
                                    type="text"
                                    className="form-control logininput"
                                    placeholder="Enter Mobile Number"
                                    onChange={(event) => {
                                      this.setState({ mobile: event.target.value });
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="mb-3 col-md-6">
                                <label
                                  className="form-label"
                                  htmlFor="inputFirstName"
                                >
                                  Enter Password{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  required
                                  type="text"
                                  onChange={(event) =>
                                    this.setState({
                                      password: event.target.value,
                                    })
                                  }
                                  className="form-control"
                                  placeholder="Enter Password"
                                />
                              </div>
                              <div className="row mb-2">
                                <div className="col-md-6 ml-3">
                                  <label
                                    className="form-label"
                                    htmlFor="inputFirstName"
                                  >
                                    Expiry{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div className="input-group d-flex">

                                    <div className="input-group-text d-flex align-items-center justify-content-center" style={{ width: '40px' }}>
                                      <FontAwesomeIcon icon={faCalendarAlt} />
                                    </div>
                                    <DatePicker
                                      className="form-control react-datepicker-popper"
                                      dateFormat="yyyy/MM/dd"
                                      value={this.state.expiryDate}
                                      onChange={this.expiryDate}
                                      selected={this.state.SelectedexpiryDate}
                                      placeholderText="Expiry Date"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row mt-3">
                              <div className="col-4">
                                <h6>Channels</h6>
                              </div>
                            </div>

                            <div className="row ml-2">
                              {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.sms_menu === 1 && this.state.userDtl.user.voice_menu === 1 && this.state.userDtl.user.email_menu === 1 && this.state.userDtl.user.whatsapp_menu === 1 && this.state.userDtl.user.rechrg_menu === 1 && this.state.userDtl.user.notify_menu === 1 && this.state.userDtl.user.rich_menu === 1 && this.state.userDtl.user.fb_menu === 1 && this.state.userDtl.user.rcs_menu === 1 && this.state.userDtl.user.chat_menu === 1 && this.state.userDtl.user.flow_menu === 1)) &&
                                <div className="form-check col-md-2">
                                  <input
                                    className="form-check-input cursor-pointer
                                  "
                                    type="checkbox"
                                    checked={
                                      this.state.checkBox.all === 1
                                        ? true
                                        : false
                                    }
                                    name="all"
                                    value={this.state.checkBox.all}
                                    onChange={this.handleCheckboxAll}
                                  />
                                  <label
                                    className="form-check-label"
                                    for="flexCheckDefault"
                                  >
                                    All
                                  </label>
                                </div>}

                              {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.sms_menu === 1)) &&
                                <div className="form-check col-md-2">
                                  <input
                                    className="form-check-input cursor-pointer
                                  "
                                    type="checkbox"
                                    checked={
                                      this.state.checkBox.sms === 1
                                        ? true
                                        : false
                                    }
                                    name="sms"
                                    value={this.state.checkBox.sms}
                                    onChange={this.handleCheckbox}
                                    id="flexCheckDefault"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="flexCheckDefault"
                                  >
                                    SMS
                                  </label>
                                </div>}

                              {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.voice_menu === 1)) &&
                                <div className="form-check col-md-2">
                                  <input
                                    className="form-check-input cursor-pointer
                                  "
                                    type="checkbox"
                                    name="voice"
                                    checked={
                                      this.state.checkBox.voice === 1
                                        ? true
                                        : false
                                    }
                                    value={this.state.checkBox.voice}
                                    onChange={this.handleCheckbox}
                                  />
                                  <label
                                    className="form-check-label"
                                    for="flexCheckDefault"
                                  >
                                    Voice
                                  </label>
                                </div>}

                              {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.email_menu === 1)) &&
                                <div className="form-check col-md-2">
                                  <input
                                    className="form-check-input cursor-pointer
                                  "
                                    type="checkbox"
                                    value={this.state.checkBox.email}
                                    checked={
                                      this.state.checkBox.email === 1
                                        ? true
                                        : false
                                    }
                                    name="email"
                                    onChange={this.handleCheckbox}
                                  />
                                  <label
                                    className="form-check-label"
                                    for="flexCheckDefault"
                                  >
                                    Email
                                  </label>
                                </div>}

                              {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.whatsapp_menu === 1)) &&
                                <div className="form-check col-md-2">
                                  <input
                                    className="form-check-input cursor-pointer
                                  "
                                    type="checkbox"
                                    name="whatsapp"
                                    value={this.state.checkBox.whatsapp}
                                    checked={
                                      this.state.checkBox.whatsapp === 1
                                        ? true
                                        : false
                                    }
                                    onChange={this.handleCheckbox}
                                  />
                                  <label
                                    className="form-check-label"
                                    for="flexCheckDefault"
                                  >
                                    Whatsapp
                                  </label>
                                </div>}

                              {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.rechrg_menu === 1)) &&
                                <div className="form-check col-md-2">
                                  <input
                                    className="form-check-input cursor-pointer
                                  "
                                    type="checkbox"
                                    name="recharge"
                                    value={this.state.checkBox.recharge}
                                    checked={
                                      this.state.checkBox.recharge === 1
                                        ? true
                                        : false
                                    }
                                    onChange={this.handleCheckbox}
                                  />
                                  <label
                                    className="form-check-label"
                                    for="flexCheckDefault"
                                  >
                                    Recharge
                                  </label>
                                </div>}

                              {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.notify_menu === 1)) &&
                                <div className="form-check col-md-2">
                                  <input
                                    className="form-check-input cursor-pointer
                                  "
                                    type="checkbox"
                                    name="notification"
                                    value={this.state.checkBox.notification}
                                    checked={
                                      this.state.checkBox.notification === 1
                                        ? true
                                        : false
                                    }
                                    onChange={this.handleCheckbox}
                                  />
                                  <label
                                    className="form-check-label"
                                    for="flexCheckDefault"
                                  >
                                    Notification
                                  </label>
                                </div>}

                              {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.rich_menu === 1)) &&
                                <div className="form-check col-md-2">
                                  <input
                                    className="form-check-input cursor-pointer
                                  "
                                    type="checkbox"
                                    name="rich_media"
                                    value={this.state.checkBox.rich_media}
                                    checked={
                                      this.state.checkBox.rich_media === 1
                                        ? true
                                        : false
                                    }
                                    onChange={this.handleCheckbox}
                                  />
                                  <label
                                    className="form-check-label"
                                    for="flexCheckDefault"
                                  >
                                    Rich Media
                                  </label>
                                </div>}

                              {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.fb_menu === 1)) &&
                                <div className="form-check col-md-2">
                                  <input
                                    className="form-check-input cursor-pointer
                                  "
                                    type="checkbox"
                                    name="fallback"
                                    value={this.state.checkBox.fallback}
                                    checked={
                                      this.state.checkBox.fallback === 1
                                        ? true
                                        : false
                                    }
                                    onChange={this.handleCheckbox}
                                  />
                                  <label
                                    className="form-check-label"
                                    for="flexCheckDefault"
                                  >
                                    Fallback
                                  </label>
                                </div>}

                              {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.rcs_menu === 1)) &&
                                <div className="form-check col-md-2">
                                  <input
                                    className="form-check-input cursor-pointer
                                  "
                                    type="checkbox"
                                    name="rcs"
                                    value={this.state.checkBox.rcs}
                                    checked={
                                      this.state.checkBox.rcs === 1
                                        ? true
                                        : false
                                    }
                                    onChange={this.handleCheckbox}
                                  />
                                  <label
                                    className="form-check-label"
                                    for="flexCheckDefault"
                                  >
                                    RCS
                                  </label>
                                </div>}

                              {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.chat_menu === 1)) &&
                                <div className="form-check col-md-2">
                                  <input
                                    className="form-check-input cursor-pointer
                                  "
                                    type="checkbox"
                                    name="chat"
                                    value={this.state.checkBox.chat}
                                    checked={
                                      this.state.checkBox.chat === 1
                                        ? true
                                        : false
                                    }
                                    onChange={this.handleCheckbox}
                                  />
                                  <label
                                    className="form-check-label"
                                    for="flexCheckDefault"
                                  >
                                    Chat
                                  </label>
                                </div>}

                              {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.flow_menu === 1)) &&
                                <div className="form-check col-md-2">
                                  <input
                                    className="form-check-input cursor-pointer
                                  "
                                    type="checkbox"
                                    name="flow"
                                    value={this.state.checkBox.flow}
                                    checked={
                                      this.state.checkBox.flow === 1
                                        ? true
                                        : false
                                    }
                                    onChange={this.handleCheckbox}
                                  />
                                  <label
                                    className="form-check-label"
                                    for="flexCheckDefault"
                                  >
                                    Flow
                                  </label>
                                </div>}
                            </div>

                            <div className="float-right">
                              <input
                                type="submit"
                                value="Add Client "
                                className="btn btn-sm  btn-primary mt-2"
                              />
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <AdminFooter />
        </div>
      </div>
    );
  }
}

export default AddNewClient;
